import { IconButton, Tooltip } from "@mui/material";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import "./basicCustomTable.css";

/**
 * Payout history row: grouped controls for automated payout vs manual settlement.
 *
 * @param {object} row — table row with id, isCompleted, isFailed
 * @param {(row: object) => void} onProcessPayout — opens confirm flow for platform / Stripe payout (retrigger)
 * @param {(row: object) => void} onMarkManuallyPaid — opens PATCH manual-status flow (failed rows only)
 */
export default function PaymentHistoryRowActions({
  row,
  onProcessPayout,
  onMarkManuallyPaid,
}) {
  const automatedDone = !!row?.isCompleted;
  const canRecordManual = !!row?.isFailed;

  return (
    <div
      className="payment-history-actions"
      role="group"
      aria-label="Payout actions"
    >
      <div className="payment-history-actions__toolbar">
        <Tooltip
          arrow
          title={
            automatedDone
              ? "Completed — automated payout already finished"
              : "Run or retry automated payout on the platform"
          }
        >
          <span>
            <IconButton
              size="small"
              aria-label="Run or retry automated payout"
              onClick={() => !automatedDone && onProcessPayout?.(row)}
              disabled={automatedDone}
              className={`payment-history-action-btn payment-history-action-btn--automated ${
                automatedDone ? "is-disabled" : "is-enabled"
              }`}
              disableRipple={automatedDone}
            >
              <CurrencyExchangeOutlinedIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </span>
        </Tooltip>

        {canRecordManual && (
          <Tooltip
            arrow
            title="Mark as manually paid — use when settlement happened outside the platform"
          >
            <span>
              <IconButton
                size="small"
                aria-label="Mark payout as manually paid"
                onClick={() => onMarkManuallyPaid?.(row)}
                className="payment-history-action-btn payment-history-action-btn--manual is-enabled"
              >
                <PlaylistAddCheckOutlinedIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </div>
    </div>
  );
}
